import { Component, Injector, Input } from "@angular/core";
import { SelectableOption, Stylable } from "../base-types";
import { BaseView } from "../base-view";

export interface StepModel extends SelectableOption{
  navigable?: boolean;
  action?: Function;
  requiredAuthorities?: string[];
  label2?: string,
  shortLabel2?: string,
  label3?: string,
  shortLabel3?: string,
}

export interface StepSettings extends Stylable{
  icon?: Stylable
  label?: Stylable
  label2?: Stylable
  label3?: Stylable
}

export interface StepperSettings extends Stylable {
  completedColor: string, //il colore assegnato agli step completati
  uncompletedColor: string, //il colore assegnato agli step ancora non completati
  linear?: boolean, //if linear you can't navigate freely between steps
  layout?: 1|2|3,
  spacing?: string,
  tileSettings?: StepSettings,
  hoverTileSettings?: StepSettings,
  selectedTileSettings?: StepSettings,
  completedTileSettings?: StepSettings,
  alignment?: 'start'|'center'|'end'
}

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent extends BaseView {
 
  @Input() tiles: StepModel[]

  @Input() set settings(_settings: StepperSettings){
    this._initSettings(_settings)
    this.lineWidth = ((Number(this.settings.spacing.split('px').join('')) * 2) + Number(this.settings.tileSettings.width.split('px').join('')))+'px'
  }
  get settings(){
    return this._settings;
  }
  _settings: StepperSettings
  
  lineWidth;
  inactiveTilesIds: string[] = []

  hoverId: string|number;
  selectedId: string|number;

  constructor(protected _injector: Injector) { 
    super(_injector);
    this._initSettings();
  }

  ngOnInit(): void {
    console.log('StepperComponent.ngOnInit');
    this.inactiveTilesIds = this.tiles.map(el=>el.id) as string[]
  }

  /** 
   * Questo è un setter non standard. 
   * Si tratta di un espediente per poter passare degli input al componente senza ricorrere a un viewChild
   */
   @Input() public set input(input: any){
    // console.log('set input :>> ', input);
    if(input && input.hasOwnProperty('selectedId')) {
      this.select(input.selectedId)
    }
  }

  public select(tileId: string|number){
    console.log('select :>> ', tileId);

    //Trovo indice della tile selezionata
    const selectedTileIndex: number = this.tiles.findIndex(el=>el.id==tileId)
    //Seleziona le tile con indice >= di quello della tile selezionata
    this.inactiveTilesIds = this.tiles.slice(selectedTileIndex).map(el=>el.id) as string[]
    
    this.selectedId = tileId;
    
    console.log('selectedTileIndex :>> ', selectedTileIndex);
    console.log('this.selectedId :>> ', this.selectedId);

  }

  public hover(tileId: string|number){
    this.hoverId = tileId;
  }

  public unhover(){
    this.hoverId = null;
  }

  private _initSettings(settings?: StepperSettings){
    const _settings = JSON.parse(JSON.stringify(settings||{}))

    _settings.linear = [null,undefined].includes(_settings.linear) ? true : _settings.linear;
    _settings.spacing = this.isXxxs ? '24px' : _settings.spacing;
    
    this._settings = _settings
  }
}

